import BaseModelAPI from '../BaseModelAPI';

export default class StockAdjustmentDetail extends BaseModelAPI {
	static entity = 'stockadjustmentdetail';
	static entityName = 'stockadjustmentdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.stockAdjustmentId = '';
			this.stockAdjustment = {};
			this.controlCardId = '';
			this.controlCard = {};
			this.partId = '';
			this.part = {};
			this.qtySytem = 0;
			this.qtyAdjustment = 0;
			this.qtyAfter = 0;
			this.reason = '';
			this.controlCardStatusBeforeId = '';
			this.controlCardStatusBefore = {};
			this.supplierCaseNumberGr = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}